import { MessageCircle, ArrowRight } from "lucide-react";
import { PLATFORM_LINKS } from "@/lib/api";

export default function WhatsAppCTA() {
  return (
    <a
      href={PLATFORM_LINKS.whatsapp}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-cta"
      className="group relative block rounded-2xl overflow-hidden p-6 md:p-8 bg-gradient-to-br from-[#25D366] to-[#128C7E] text-white jt-medium-shadow transition-transform hover:-translate-y-1"
    >
      <div className="absolute -right-8 -top-8 w-40 h-40 rounded-full bg-white/10" />
      <div className="absolute -right-16 -bottom-16 w-56 h-56 rounded-full bg-white/5" />
      <div className="relative flex items-center gap-4 mb-4">
        <div className="h-12 w-12 rounded-full bg-white/20 backdrop-blur flex items-center justify-center">
          <MessageCircle className="w-6 h-6" strokeWidth={1.75} />
        </div>
        <div>
          <p className="text-xs uppercase tracking-widest text-white/80">Communauté</p>
          <h4 className="font-serif text-2xl leading-tight">Rejoins la chaîne WhatsApp</h4>
        </div>
      </div>
      <p className="relative text-white/90 max-w-lg mb-5">
        Reçois les nouveaux épisodes, versets et rendez-vous en direct dans ta poche. Une famille de foi qui marche ensemble.
      </p>
      <span className="relative inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-[#128C7E] text-sm font-medium group-hover:gap-3 transition-all">
        Rejoindre <ArrowRight className="w-4 h-4" />
      </span>
    </a>
  );
}
